export { Heading, type HeadingProps } from './Heading';
export { headingVariants, type HeadingVariantProps } from './heading.variants';
